import React, { FC, useEffect } from "react";
import OnboardingPatientInfoForm from "@components/Onboarding/OnboardingPatientInfoForm/OnboardingPatientInfoForm";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";
import {
  isAddPatientFlow,
  withOnboardingFlow,
} from "@components/Onboarding/onboardingFlow";

const PatientInfo: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const isCreatePatientMode = isAddPatientFlow(location.search) && !id;
  const effectivePatientId = id || (isCreatePatientMode ? null : patientId);
  const { data: patient, isLoading } = useGetPatientQuery(effectivePatientId!, {
    skip: !effectivePatientId,
  });

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!isCreatePatientMode && !patient && !isLoading) {
      navigate(withOnboardingFlow("/onboarding/profile", location.search));
    }
  }, [
    patient,
    navigate,
    accountId,
    isLoading,
    isCreatePatientMode,
    location.search,
  ]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <OnboardingPatientInfoForm patient={isCreatePatientMode ? null : patient} />
      )}
    </>
  );
};

export default PatientInfo;
